<template>
    <div>
        <img
            src="/statics/app-logo.png"
            alt="app-logo"
            class="app-logo"
        >
    </div>
</template>

<script>
export default {
    name: "appLogo"
}
</script>

<style scoped>
    .app-logo{
        width: 100%;
        height: auto;
        display: inline-block;
        margin: 0 5px;
        max-width: 4rem;
    }
</style>
